import { ReactElement, useEffect, useState } from "react";
import { cn, getFormattedTime } from "@util/helpers";

export type CreateTimeProps = {
  rootClassName?: string;
  created: string;
  dateFormat?: string;
};

/**
 * CreateTime
 * Description: The create time of the article
 * @param {CreateTimeProps} props
 * @returns {ReactElement}
 * @deprecated
 */
export default function CreateTime({
  rootClassName,
  created,
  dateFormat,
}: CreateTimeProps): ReactElement {
  const [publishedDate, setPublishedDate] = useState("");

  useEffect(() => {
    setPublishedDate(getFormattedTime(created, dateFormat));
  }, [created, dateFormat]);

  return (
    <div
      className={cn(
        "truncate font-poppins text-7xs uppercase text-gray-550",
        rootClassName
      )}
      data-testid="create-time-component"
    >
      {publishedDate}
    </div>
  );
}
